export default {
  strict: true,
  namespaced: true,
  state: {
    countryName: '',
    countryCode: '',
    callingCode: '',
    countryList: {},
    countryOnly: false,
    countryModal: false
  },
  mutations: {
    setCountryName (state, countryName) {
      state.countryName = countryName
    },
    setCountryCode (state, countryCode) {
      state.countryCode = countryCode
    },
    setCallingCode (state, callingCode) {
      state.callingCode = callingCode
    },
    setCountryOnly (state, value) {
      state.countryOnly = value
    },
    setCountryList (state, value) {
      state.countryList = value
    },
    setCountryModal (state, value) { state.countryModal = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/consumer/country-select.js